/// <amd-module name="Tfs/ReduxCommon/Modules/Teams/TeamActions" />
import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

import { ITeam } from "Tfs/ReduxCommon/Contracts/Team";

export const TeamActionsCreator = {
    beginLoadTeams: () => createAction(TeamActionTypes.BeginLoadTeams),
    loadTeamsRequested: () => createAction(TeamActionTypes.LoadTeamsRequested),
    loadTeamsSucceeded: (teams: ITeam[]) => createAction(TeamActionTypes.LoadTeamsSucceeded, teams),
    loadTeamsFailed: (error: string) => createAction(TeamActionTypes.LoadTeamsFailed, error)
};

export const enum TeamActionTypes {
    BeginLoadTeams = "Teams/BeginLoadTeams",
    LoadTeamsRequested = "Teams/LoadTeamsRequested",
    LoadTeamsSucceeded = "Teams/LoadTeamsSuceeded",
    LoadTeamsFailed = "Teams/LoadTeamsFailed"
}

export type TeamActions = ActionsUnion<typeof TeamActionsCreator>;
